import { generate, getFilteredStyles, getStringStyle } from '@/utils/GeneratePartHTML'
import Juice from 'juice'
import { inlineDefaultCssString } from '@/components/Content/Check/inlineDefaultCss'
import { partDefaultPadding, defaultFontFamily } from '@/scss/variables.scss'
import constants from '@/constants'

const CLOSE_TAG = `</td></tr></tbody></table>`
const DEFAULT_PADDING = partDefaultPadding
const DEFAULT_FONT_FAMILY = defaultFontFamily

const TABLE_DEFAULT_ATTRS = 'border="0" cellpadding="0" cellspacing="0"'
const MARGIN_CENTER = '0 auto'
const MARGIN_LEFT = '0 auto 0 0'
const MARGIN_RIGHT = '0 0 0 auto'

const innerRegExp = new RegExp('^inner_')

export default {
  methods: {
    createContentCSS () {
      const contentStyles = this.$store.getters.findContentStyles
      if (contentStyles.length === 0) return ''
      let contentCSS = '<style>'
      // セレクタの一覧を作成：h1〜h4の見出し
      let selectors = ['h1', 'h2', 'h3', 'h4']
      // セレクタの一覧を作成：各セクション リンクテキスト
      // .section-header a の形
      const sections = this.$store.getters.getSectionAll
      sections.forEach(section => {
        selectors.push(`.section-${section.name} a`)
      })
      // セレクタごとのスタイルを作成
      selectors.forEach(selector => {
        const styles = contentStyles.filter(contentStyle => contentStyle.selector === selector && contentStyle.prop !== 'font-family-name')
        if (styles.length > 0) {
          // 以下の形に整形
          // selector {
          //  prop: value;
          // }
          let styleText = ` ${selector} { `
          styles.forEach(style => {
            if (style.value) styleText += `${style.prop}: ${style.value};`
          })
          contentCSS += styleText + ' }'
        }
      })
      contentCSS += `}</style>`
      return contentCSS
    },
    createMobileCSS () {
      const width = this.$store.getters.noUnitScssVars.mobileCSSWidth
      const mobileStyles = this.$store.getters.findMobileStyles
      // モバイル用のスタイル設定がない場合、何もしない
      if (mobileStyles.length === 0) return null

      // スタイルタグの内容を作成して返す
      let mobileCSS = `@media screen and (max-width: ${width}px) {`
      // セレクタの一覧を作成：h1〜h4の見出し、テキストボックス
      let selectors = ['h1', 'h2', 'h3', 'h4', '.part-boxed-text']
      // セレクタの一覧を作成：各セクション
      const sections = this.$store.getters.getSectionAll
      sections.forEach(section => {
        selectors.push(`.section-${section.name}`)
      })
      // セレクタごとのスタイルを作成
      selectors.forEach(selector => {
        const styles = mobileStyles.filter(mobileStyle => mobileStyle.selector === selector)
        if (styles.length > 0) {
          // 以下の形に整形
          // selector {
          //  prop: value !important;
          // }
          let styleText = ` ${selector} { `
          styles.forEach(style => {
            // importantを付けないと、インラインのスタイルが優先される
            if (style.value) styleText += `${style.prop}: ${style.value} !important;`
          })
          mobileCSS += styleText + ' }'
        }
      })
      mobileCSS += `}`
      return mobileCSS
    },
    createHeadCSS () {
      let headCSS = ''
      headCSS = `
        body {
          color: #000000;
          background-color: #FFFFFF;
          margin: 0;
          padding: 0;
          width: 100%;
          -webkit-text-size-adjust: 100%;
          font-size: 16px;
          font-family: inherit !important;
        }
        ${this.$store.getters.findOriginalHeadStyle || ''}
        @media screen and (max-width: 480px) {
          .mphe-image-content {
            width: 100% !important;
          }
          .mphe-image-content-mobile-full-width {
            width: 100% !important;
            max-width: none !important;
          }
          .mphe-section-content {
            padding-right: 0px;
            padding-left: 0px;
          }
          .mobile-width {
            width: 100% !important;
          }
          .mobile-display {
            display: block !important;
            width: 100% !important;
          }
          .image-card-img-width {
            width: 100%;
          }
        }`
      return headCSS
    },
    createOutlookCSS () {
      let outlookCSS = ''
      outlookCSS = `
        h1, h2, h3, h4 {
          font-size: 16px;
          font-weight: lighter;
        }
        table, tr, td {
          border-collapse: collapse;
        }
        tr {
          font-size: 16px;
          line-height: 0px;
          border-collapse: collapse;
        }`
      return outlookCSS
    },
    createRawHTML (sections = this.$store.getters.getSectionAll, linkParams = this.$store.getters.getContentInfoLinkParams, isLinkChecker = false) {
      sections = JSON.parse(JSON.stringify(sections)) // deep copy
      const width = this.$store.getters.noUnitScssVars.contentsWidth
      const preheader = this.$store.getters.getContentInfoPreheader
      this.rawHTML = ''
      if (preheader) {
        let preheaderText = this.$utils.string.sanitizeEncode(preheader)
        preheaderText = this.$utils.string.sanitizeEncodeBr(preheaderText)
        this.rawHTML += `
          <p style="display:none !important; visibility:hidden; height:0; width:0; font-size:0; color:rgba(0,0,0,0); opacity:0; mso-hide:all;">
            ${preheaderText}
          </p>
        `
      }
      this.rawHTML += `
        <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; margin: 0 auto; font-family: ${DEFAULT_FONT_FAMILY};">
        <!--[if mso]>
          <tr>
            <td>
              <table class="mobile-width" ${TABLE_DEFAULT_ATTRS} width="${width}" align="center">
        <![endif]-->
          <tbody>
            <tr>
              <td>
      `
      for (const section of sections) {
        // セクションのスタイル：inner_ で始まるものは除外
        const sectionKeys = Object.keys(section.styles).filter(key => {
          return (!innerRegExp.test(key))
        })
        // セクション内側のスタイル：inner_ で始まるものだけ
        const sectionInnerKeys = Object.keys(section.styles).filter(key => {
          return (innerRegExp.test(key))
        })
        const filteredSectionStyles = getFilteredStyles(section.styles, sectionKeys)
        const filterdSectionInnerStyles = getFilteredStyles(section.styles, sectionInnerKeys)
        const sectionClass = `section-${section.name} mphe-section-content`
        this.rawHTML += `
          <table align="center" style="width: 100%; margin: 0 auto;" border="0" cellpadding="20" cellspacing="0">
            <tbody>
              <tr>
                <td class="${sectionClass}" style="${getStringStyle(filteredSectionStyles)}">
                  <table class="mobile-width" ${TABLE_DEFAULT_ATTRS} align="center" style="width: ${width}px; margin: 0 auto;">
                    <tbody>
                      <tr>
                        <td style="${getStringStyle(filterdSectionInnerStyles)}">
        `
        this.generatePartsContainer(section, width, linkParams, isLinkChecker)
        this.rawHTML += CLOSE_TAG + CLOSE_TAG
      }
      this.rawHTML += `
                    </td>
                  </tr>
                </tbody>
        <!--[if mso]>
              </table>
            </td>
          </tr>
        <![endif]-->
        </table>
      `
      const originalStyle = `<style>${this.$store.getters.findAppliedOriginalStyle}</style>`
      this.rawHTML = Juice(this.rawHTML + inlineDefaultCssString + this.createContentCSS() + originalStyle)
    },
    generatePartsContainer (section, width, linkParams, isLinkChecker = false) {
      for (const partsContainer of section.parts_containers) {
        if (partsContainer.type === 'ImageCard') {
          // 画像カード用の暫定対応
          this.rawHTML += this.generatePartsContainerImageCardTag(section, partsContainer, width, linkParams, isLinkChecker)
          this.rawHTML += CLOSE_TAG
        } else {
          const mobileDisplayStyle = Number(partsContainer.flg_side) ? '' : 'class="mobile-display"'
          if (partsContainer.type === 'FollowButton' || partsContainer.type === 'Share') {
            // フォローボタン・シェアボタン用の暫定対応
            // スタイル取得
            const followButton = constants.partsContainer.followButton
            const followButtonWrapperStyles = getFilteredStyles(partsContainer.styles, followButton.wrapperStyleKeys)
            const followButtonPartsContainerStyles = getFilteredStyles(partsContainer.styles, followButton.containerStyleKeys)
            // 表示位置の設定：レイアウトタイプで設定するスタイルを分ける
            const align = partsContainer.styles['align']
            let followButtonContainerStyle = ''
            let followButtonInnerStyle = ''
            let outlookOpenTableTag = ''
            let outlookOpenTdTag = ''
            let outlookCloseTableTag = ''
            let outlookCloseTdTag = ''
            if (partsContainer.layout_type.match(/horizontal/)) {
              // 横レイアウト：表示位置はtext-alignで設定
              followButtonContainerStyle = { 'width': '100%', 'margin': MARGIN_CENTER }
              followButtonInnerStyle = { 'text-align': align }
              outlookOpenTableTag = `<!--[if mso]><table align="${align}"><tr><![endif]-->`
              outlookOpenTdTag = `<!--[if mso]><td align="center" valign="top"><![endif]-->`
              outlookCloseTableTag = `<!--[if mso]></tr></table><![endif]-->`
              outlookCloseTdTag = `<!--[if mso]></td><![endif]-->`
            } else if (partsContainer.layout_type.match(/vertical/)) {
              // 縦レイアウト：表示位置はmarginで設定
              switch (align) {
                case 'center':
                  followButtonContainerStyle = { 'margin': MARGIN_CENTER }
                  break
                case 'left':
                  followButtonContainerStyle = { 'margin': MARGIN_LEFT }
                  break
                case 'right':
                  followButtonContainerStyle = { 'margin': MARGIN_RIGHT }
                  break
              }
            }
            this.rawHTML += `
              <table class="mobile-width" ${TABLE_DEFAULT_ATTRS} style="width: ${width}px; margin: ${MARGIN_CENTER};">
                <tbody>
                  <tr>
                    <td style="padding: ${DEFAULT_PADDING}; ${getStringStyle(this.getPartsContainerOuterStyles(followButtonPartsContainerStyles))}">
                      <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; ${getStringStyle(followButtonWrapperStyles)}">
                        <tbody>
                          <tr>
                            <td>
                              <table ${TABLE_DEFAULT_ATTRS} style="${getStringStyle(followButtonContainerStyle)}" align="${align}">
                                <tbody>
                                  <tr>
                                    <td style="width: 100%; padding-top: ${DEFAULT_PADDING}; ${getStringStyle(followButtonInnerStyle)}">
                                      ${outlookOpenTableTag}`
            partsContainer.parts.forEach(part => {
              this.rawHTML += outlookOpenTdTag + generate({
                part: part,
                partsContainerType: partsContainer.type,
                layoutType: partsContainer.layout_type,
                flgImageContentMobileFullWidth: partsContainer.flg_image_content_mobile_full_width,
                linkParams: linkParams,
                isLinkChecker: isLinkChecker,
                shareText: partsContainer.share_text,
              }) + outlookCloseTdTag
            })
            this.rawHTML += outlookCloseTableTag + CLOSE_TAG + CLOSE_TAG + CLOSE_TAG
          } else if (partsContainer.layout_type === 'vertical') {
            // 縦レイアウト
            this.rawHTML += `
              <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; margin: 0 auto;">
                <tbody>
                  <tr>
                    <td style="width: 100%; ${getStringStyle(this.getPartsContainerOuterStyles(partsContainer.styles))}">
                      <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; margin: 0 auto;">
                        <tbody>
            `
            for (let tableCount = 1; tableCount <= partsContainer.table_count; tableCount++) {
              // table_countの数だけ、tr要素を作る
              this.rawHTML += `<tr>`
              this.sortParts(partsContainer.parts, tableCount).forEach(part => {
                this.rawHTML += `<td ${mobileDisplayStyle} style="${getStringStyle(this.verticalAlignStyle(partsContainer))} ${getStringStyle(this.partBaseStyle(partsContainer, width, part))}">`
                this.rawHTML += generate({
                  part: part,
                  partsContainerType: partsContainer.type,
                  layoutType: null,
                  flgImageContentMobileFullWidth: partsContainer.flg_image_content_mobile_full_width,
                  linkParams: linkParams,
                  isLinkChecker: isLinkChecker,
                  sectionStyles: section.styles,
                  shareText: partsContainer.share_text,
                }) + '</td>'
              })
              this.rawHTML += `</tr>`
            }
            this.rawHTML += `</tbody></table></td></tr></tbody></table>`
          } else if (partsContainer.layout_type === 'horizontal') {
            // 横レイアウト
            this.rawHTML += `
              <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; margin: 0 auto;">
                <tbody>
                  <tr>
                    <td style="${getStringStyle(this.getPartsContainerOuterStyles(partsContainer.styles))}">
                      <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; margin: 0 auto;">
                        <tbody>
                          <tr>
            `
            const imageParts = partsContainer.parts.filter(part => part.type === 'Image')
            for (let tableCount = 1; tableCount <= partsContainer.table_count; tableCount++) {
              // モバイル表示：横並びレイアウトでコンテンツの大きさが異なるため、スペーサー以外に width を設定する
              // 画像テキストの1カラムは表示比率変更が効かなくなるため除外する
              let divideWidth = ''
              if (Number(partsContainer.flg_side) && !(partsContainer.type === 'ImageText' && imageParts.length === 1)) {
                const columnCount = partsContainer.column_count
                // column_count と table_count が同じ →  間隔の調整の値が0でスペーサーなし
                if (columnCount === partsContainer.table_count || (columnCount * 2 - 1 === partsContainer.table_count && tableCount % 2)) {
                  divideWidth = `width="${(100 / columnCount).toFixed(3)}%"`
                }
              }
              // table_countの数だけ、td要素を作る
              this.rawHTML += `<td ${mobileDisplayStyle} ${divideWidth} style="${getStringStyle(this.verticalAlignStyle(partsContainer))}">`
              // table_countのループ数と、table_idが一致するものをループして、テーブルを作る
              this.sortParts(partsContainer.parts, tableCount).forEach(part => {
                this.rawHTML += `<table ${TABLE_DEFAULT_ATTRS} width="100%"><tbody><tr>`
                this.rawHTML += `<td style="${getStringStyle(this.partBaseStyle(partsContainer, width, part))}">`
                this.rawHTML += generate({
                  part: part,
                  partsContainerType: partsContainer.type,
                  layoutType: null,
                  flgImageContentMobileFullWidth: partsContainer.flg_image_content_mobile_full_width,
                  linkParams: linkParams,
                  isLinkChecker: isLinkChecker,
                  sectionStyles: section.styles
                })
                this.rawHTML += `</td>`
                this.rawHTML += `</tr></tbody></table>`
              })
              this.rawHTML += `</td>`
            }
            this.rawHTML += `</tr></tbody></table></td></tr></tbody></table>`
          }
        }
      }
    },
    // 画像カード用：HTML生成 ※パーツコンテナとパーツをまとめて生成
    generatePartsContainerImageCardTag (section, partsContainer, width, linkParams, isLinkChecker = false) {
      let returnHTML = null
      let imageCardParts
      const imageCardPartsContainerKeys = Object.keys(partsContainer.styles)
      // パーツコンテナのスタイル：外側と内側に分けて取得
      // 外側：padding, outer- 内側：padding以外(inner_paddingを含む)
      const wrapperStyleKeys = imageCardPartsContainerKeys.filter(key => /^(padding-|outer-)/.test(key))
      const innerStyleKeys = imageCardPartsContainerKeys.filter(key => !/^(padding-|outer-)/.test(key))
      const imageCardWrapperStyles = getFilteredStyles(partsContainer.styles, wrapperStyleKeys)
      const imageCardInnerStyles = getFilteredStyles(partsContainer.styles, innerStyleKeys)
      // 共通レイアウト
      returnHTML = `
        <table class="mobile-width" ${TABLE_DEFAULT_ATTRS} style="width: ${width}px; margin: ${MARGIN_CENTER};">
          <tbody>
            <tr>
              <td style="width: 100%; ${getStringStyle(this.getPartsContainerOuterStyles(imageCardWrapperStyles))}">
                <table ${TABLE_DEFAULT_ATTRS} style="width: 100%; ${getStringStyle(imageCardInnerStyles)}">
                  <tbody>
                    <tr>`
      if (partsContainer.layout_type === 'vertical') {
        // 縦レイアウト
        returnHTML += `
          <td style="width: 100%; padding: 0;">
            <table ${TABLE_DEFAULT_ATTRS} style="width: 100%;">
              <tbody>`
        // tableCountの数だけ、tr要素を作る
        for (let tableCount = 1; tableCount <= partsContainer.table_count; tableCount++) {
          returnHTML += `<tr>`
          // tableCountとtableIdが一致するパーツを取得：orderId順に並び替える
          imageCardParts = this.sortParts(partsContainer.parts, tableCount)
          // パーツ1つ分の幅を取得
          const partWidth = this.getImagePartWidth(partsContainer, width)
          // パーツの数だけ、td要素を作る
          imageCardParts.forEach(part => {
            returnHTML += `<td style="${getStringStyle(this.verticalAlignStyle(partsContainer))} padding: 0; width: ${partWidth};">`
            returnHTML += generate({
              part: part,
              partsContainerType: partsContainer.type,
              layoutType: partsContainer.layout_type,
              flgImageContentMobileFullWidth: partsContainer.flg_image_content_mobile_full_width,
              linkParams: linkParams,
              isLinkChecker: isLinkChecker,
              sectionStyles: section.styles
            }) + '</td>'
          })
          returnHTML += `</tr>`
        }
        returnHTML += '</tbody></table>' + CLOSE_TAG
      } else if (partsContainer.layout_type === 'horizontal') {
        // 横レイアウト
        // tableCountの数だけ、td要素を作る
        for (let tableCount = 1; tableCount <= partsContainer.table_count; tableCount++) {
          // tableCountとtableIdが一致するパーツを取得：orderId順に並び替える
          imageCardParts = this.sortParts(partsContainer.parts, tableCount)
          if (!imageCardParts[0] || !imageCardParts[0].type) {
            continue
          }
          // 表示比率を反映させた幅を取得
          const imageCardPartWidth = this.getImageCardHorizontalPartWidth(partsContainer, imageCardParts[0].type, width)

          returnHTML += `<td class="mobile-display" style="${getStringStyle(this.verticalAlignStyle(partsContainer))} padding: 0; width: ${imageCardPartWidth};">`
          // パーツの数だけ、table要素を作る
          imageCardParts.forEach(part => {
            returnHTML += generate({
              part: part,
              partsContainerType: partsContainer.type,
              layoutType: partsContainer.layout_type,
              flgImageContentMobileFullWidth: partsContainer.flg_image_content_mobile_full_width,
              linkParams: linkParams,
              isLinkChecker: isLinkChecker,
              sectionStyles: section.styles
            })
          })
          returnHTML += '</td>'
        }
        returnHTML += '</tr></tbody></table>'
      }
      return returnHTML
    },
    verticalAlignStyle (partsContainer) {
      const value = partsContainer.styles['vertical-align'] ? partsContainer.styles['vertical-align'] : 'top'
      return { 'vertical-align': value }
    },
    partBaseStyle (partsContainer, width, part) {
      const paddingRight = partsContainer.styles['padding-right'] ? Number(partsContainer.styles['padding-right'].replace('px', '')) : 0
      const paddingLeft = partsContainer.styles['padding-left'] ? Number(partsContainer.styles['padding-left'].replace('px', '')) : 0
      // スペーサーの合計幅
      let spacerWidth = 0
      let spacerParts
      // パーツ個別の幅
      let partWidth
      if (partsContainer.layout_type === 'horizontal' && partsContainer.type !== 'ImageText') {
        // 横レイアウトで、画像テキスト以外：全スペーサーを取得
        spacerParts = partsContainer.parts.filter(part => part.type === 'Spacer')
      } else if (partsContainer.layout_type === 'horizontal' && partsContainer.type === 'ImageText') {
        // 横レイアウトで、画像テキスト
        const imageParts = partsContainer.parts.filter(part => part.type === 'Image')
        if (imageParts.length === 1) {
          // 画像数が1：全スペーサーを取得
          spacerParts = partsContainer.parts.filter(part => part.type === 'Spacer')
          const displayRatio = this.imageCardpartRatiofromTheWhole(partsContainer.horizontal_display_ratio, part.type)
          partWidth = ((Number(width) - paddingLeft - paddingRight - Number(spacerParts[0].attrs.width.replace('px', ''))) * displayRatio).toFixed(3)
        } else if (imageParts.length >= 2) {
          // 画像数が2以上：単体で表示されているスペーサーを取得
          spacerParts = partsContainer.parts.filter(part => part.type === 'Spacer' && part.order_id === 1)
          if (spacerParts.length) {
            spacerWidth = Number(spacerParts[0].attrs.width.replace('px', ''))
          }
          partWidth = ((Number(width) - paddingLeft - paddingRight - spacerWidth) / partsContainer.column_count).toFixed(3)
        }
      } else if (partsContainer.layout_type === 'vertical' && partsContainer.type === 'ImageText') {
        // 縦レイアウトで、画像テキスト
        const imageParts = partsContainer.parts.filter(part => part.type === 'Image')
        if (imageParts.length === 1) {
          // 画像数が1
          spacerParts = partsContainer.parts.filter(part => part.type === 'Spacer')
          partWidth = ((Number(width) - paddingLeft - paddingRight - spacerParts[0].attrs.width.replace('px', '')) / partsContainer.column_count).toFixed(3)
        } else if (imageParts.length >= 2) {
          // 画像数が2以上：代表で、1行目のスペーサーを取得
          // 全行のスペーサーの幅は同じ
          spacerParts = partsContainer.parts.filter(part => part.type === 'Spacer' && part.table_id === 1)
          if (spacerParts.length) {
            spacerWidth = Number(spacerParts[0].attrs.width.replace('px', ''))
          }
          const displayRatio = this.imageCardpartRatiofromTheWhole(partsContainer.horizontal_display_ratio, part.type)
          partWidth = ((Number(width) - paddingLeft - paddingRight - spacerWidth) * displayRatio).toFixed(3)
        }
      }

      if (part && part.type === 'Spacer') {
        // スペーサー：スペーサーの幅
        partWidth = part.attrs.width.replace('px', '')
      } else if (partsContainer.type !== 'ImageText') {
        // それ以外：( メールの幅 - パーツコンテナの左右余白 - スペーサーの合計幅 ) - カラム数
        // 桁数が大きくなる可能性があるため、小数点第3位に揃える

        // 取得したスペーサーの幅を合計する
        if (spacerParts && spacerParts.length > 0) {
          spacerParts.forEach(spacerPart => {
            spacerWidth += spacerPart.attrs.width ? Number(spacerPart.attrs.width.replace('px', '')) : 0
          })
        }
        const columnCount = partsContainer.type === 'ImageGroup' && partsContainer.layout_type === 'vertical' ? 1 : partsContainer.column_count
        partWidth = ((Number(width) - paddingLeft - paddingRight - spacerWidth) / columnCount).toFixed(3)
      }
      return {
        'width': partWidth + 'px',
        'margin-left': 'auto',
        'margin-right': 'auto',
        'border-collapse': 'collapse',
      }
    },
    // 指定のテーブルIDのパーツを、orderID順に並び替えて返す
    sortParts (parts, tableId) {
      return parts.filter(part => part.table_id === tableId).sort((a, b) => {
        if (a.order_id < b.order_id) return -1
        if (a.order_id > b.order_id) return 1
        return 0
      })
    },
    // TODO: 同じ処理がパーツのプレビューにあるので、タイミングを見て共通化したい
    getImagePartWidth (partsContainer, defaultWidth) {
      const partsContainerStyles = { ...partsContainer.styles }
      const defaultPadding = Number(DEFAULT_PADDING.replace('px', ''))
      // パーツコンテナの罫線幅を取得
      let borderWidth = 0
      if (partsContainerStyles['border']) {
        // スタイルは border 1px solid の形になっているので、インデックス1番が線の太さ
        const borderStyles = partsContainerStyles['border'].split(' ')
        borderWidth = Number(borderStyles[1].replace(/px/g, '')) * 2
      }
      // 画像ポジションによって、パーツの幅を決定
      const imagePosition = this.getImagePosition(partsContainer)
      let partWidth
      if (imagePosition === 'Top' || imagePosition === 'Bottom') {
        // Top・Bottom：パーツ幅基本値 - 左右の余白 - 罫線の幅
        partWidth = (defaultWidth - (defaultPadding * 2) - borderWidth) + 'px'
      } else if (imagePosition === 'Right' || imagePosition === 'Left') {
        // Right・Left：パーツ幅基本値 - 左右片方の幅 - 罫線の幅
        partWidth = (defaultWidth - defaultPadding - borderWidth) + 'px'
      }
      return partWidth
    },
    getImageCardHorizontalPartWidth (partsContainer, partType, partsWidthSum) {
      // 画像カード(horizontal)内の各パーツの幅だけ計算して getImagePartWidth の結果を返す
      const displayRatio = this.imageCardpartRatiofromTheWhole(partsContainer.horizontal_display_ratio, partType)
      const width = (partsWidthSum * displayRatio).toFixed(3)
      return this.getImagePartWidth(partsContainer, width)
    },
    // 画像カード用：画像のポジションを取得
    // TODO: 画像パーツ側に似た処理があるので、タイミングを見て共通化したい
    getImagePosition (partsContainer) {
      const imagePartCount = partsContainer.parts.filter(part => part.type === 'Image').length
      const layoutType = partsContainer.layout_type
      let imagePart
      let imagePosition
      if (imagePartCount === 1) {
        // 画像数：1の場合
        imagePart = partsContainer.parts.find(part => part.type === 'Image')
        if (layoutType === 'vertical' && imagePart.table_id === 1) {
          // レイアウト[縦] テーブルID[1]：Top
          imagePosition = 'Top'
        } else if (layoutType === 'vertical' && imagePart.table_id === 2) {
          // レイアウト[縦] テーブルID[2]：Bottom
          imagePosition = 'Bottom'
        } else if (layoutType === 'horizontal' && imagePart.table_id === 1) {
          // レイアウト[横] テーブルID[1]：Left
          imagePosition = 'Left'
        } else if (layoutType === 'horizontal' && imagePart.table_id === 2) {
          // レイアウト[横] テーブルID[2] Right
          imagePosition = 'Right'
        }
      } else if (imagePartCount > 1) {
        // 画像数：2以上の場合 → 画像パーツの位置を判定するために、代表でテーブルID[1]の画像パーツを取得
        imagePart = partsContainer.parts.find(part => part.type === 'Image' && part.table_id === 1)
        if (layoutType === 'vertical' && imagePart.order_id === 1) {
          // レイアウト[縦] 並び順[1]：Left
          imagePosition = 'Left'
        } else if (layoutType === 'vertical' && imagePart.order_id === 2) {
          // レイアウト[縦] 並び順[2]：Right
          imagePosition = 'Right'
        } else if (layoutType === 'horizontal' && imagePart.order_id === 1) {
          // レイアウト[横] 並び順[1]：Top
          imagePosition = 'Top'
        } else if (layoutType === 'horizontal' && imagePart.order_id === 2) {
          // レイアウト[横] 並び順[2]：Bottom
          imagePosition = 'Bottom'
        }
      }
      return imagePosition
    },
    imageCardpartRatiofromTheWhole (horizontalDisplayRatio, partType) {
      // 画像カードの各パーツの全体からの表示比率を返す
      switch (horizontalDisplayRatio) {
        case 'imageOneToTextOne':
          return 1 / 2
        case 'imageTwoToTextOne':
          return partType === 'Image' ? 2 / 3 : 1 / 3
        case 'imageOneToTextTwo':
          return partType === 'Image' ? 1 / 3 : 2 / 3
        case 'imageOneToTextThree':
          return partType === 'Image' ? 1 / 4 : 3 / 4
        default:
          return 1 / 2
      }
    },
    async getTestPublicSections ({ type }) {
      // data-keyをフォームデータに追加
      const formData = new FormData()
      this.$store.getters.getSectionAll.forEach(section => {
        section.parts_containers.forEach(partsContainer => {
          partsContainer.parts.forEach(part => {
            if (part.type === 'Image' && part.attrs && !part.attrs['data-external-url'] && part.attrs['data-image-key']) {
              formData.append('keys[]', part.attrs['data-image-key'])
            } else if (part.type === 'Code' && part.attrs) {
              part.attrs.forEach(attr => {
                if (!attr['data-external-url'] && attr['data-image-key']) {
                  formData.append('keys[]', attr['data-image-key'])
                }
              })
            }
          })
        })
      })
      if (!formData.get('keys[]')) {
        // 画像がセットされていない時はsectionsをそのまま返す
        return this.$store.getters.getSectionAll
      }
      // S3のオブジェクトキーの一部に使用する
      formData.append('type', type)

      // 公開バケットのURLを取得
      const json = await this.$http({
        url: '/image/create_test_public',
        type: 'POST',
        params: formData,
      })

      const privateBucketUrls = this.$utils.image.getMultiplePrivateBucketUrl()

      // 取得した公開バケットのURLをセット
      if (json && json.status === 200) {
        const urls = json.data.urls
        const publicSections = this.$store.getters.getSectionAll.map(section => {
          return {
            ...section,
            parts_containers: section.parts_containers.map(partsContainer => {
              return {
                ...partsContainer,
                parts: partsContainer.parts.map(part => {
                  if (part.type === 'Image' && !part.attrs['data-external-url'] && part.attrs['data-image-key']) {
                    return {
                      ...part,
                      attrs: {
                        ...part.attrs,
                        src: decodeURIComponent(urls[part.attrs['data-image-key']]),
                      }
                    }
                  } else if (part.type === 'Code' && part.attrs && part.body) {
                    // bodyのURLを置換
                    let body = part.body
                    part.attrs.forEach(attr => {
                      if (!attr['data-key'] || !attr['data-image-key']) return
                      const reg = new RegExp(`src="(${privateBucketUrls[0]}|${privateBucketUrls[1]})/${attr['data-key']}\\S+"`, 'g')
                      body = body.replace(reg, 'src="' + urls[attr['data-image-key']] + '"')
                    })
                    // attr.srcは処理不要
                    return { ...part, body }
                  } else {
                    return part
                  }
                })
              }
            })
          }
        })
        return publicSections
      }
      return null
    },
    async getReplacedUrlSections (randContentId, type) {
      // 画像URLを置換したsectionsを返す
      // コピー先のcontentIDが不明なので、ランダム文字列で埋め込んでおく
      // (サーバー側では、このランダム文字列を、作成したcontentIDで置換する)
      const privateBucketUrls = this.$utils.image.getMultiplePrivateBucketUrl()

      return this.$store.getters.getSectionAll.map(section => {
        return {
          ...section,
          parts_containers: section.parts_containers.map(partsContainer => {
            return {
              ...partsContainer,
              parts: partsContainer.parts.map(part => {
                // 公開バケットURLのタイプ名 typeがec_v1の場合、ecとする
                const typeName = type === 'ec_v1' ? 'ec' : type
                if (part.type === 'Image' && part.attrs && !part.attrs['data-external-url'] && part.attrs['data-key']) {
                  const [ prefixAndSiteId, , uuid, tmpUuid ] = part.attrs['data-key'].split('/')
                  let url = ''
                  if (type === 'rel_export') {
                    // ランダムメーリングIDに置換のみ
                    url = `${privateBucketUrls[0]}/${prefixAndSiteId}/${randContentId}/${uuid}/${tmpUuid}`
                  } else {
                    // 公開バケットURL
                    url = `${process.env.VUE_APP_S3_PUBLIC_URL}/${prefixAndSiteId}/${randContentId}/${typeName}/${uuid}`
                  }
                  return {
                    ...part,
                    attrs: {
                      ...part.attrs,
                      src: url
                    }
                  }
                } else if (part.type === 'Code' && part.attrs && part.body) {
                  let body = part.body
                  part.attrs.forEach(attr => {
                    if (!attr['data-key'] || !attr['data-image-key']) return
                    const [ prefixAndSiteId, , uuid, tmpUuid ] = attr['data-key'].split('/')
                    let url = ''
                    if (type === 'rel_export') {
                      // ランダムメーリングIDに置換のみ
                      url = `${privateBucketUrls[0]}/${prefixAndSiteId}/${randContentId}/${uuid}/${tmpUuid}`
                    } else {
                      // 公開バケットURL
                      url = `${process.env.VUE_APP_S3_PUBLIC_URL}/${prefixAndSiteId}/${randContentId}/${typeName}/${uuid}`
                    }
                    // bodyのURLを置換
                    const reg = new RegExp(`src="(${privateBucketUrls[0]}|${privateBucketUrls[1]})/${attr['data-key']}\\S+"`, 'g')
                    body = body.replace(reg, 'src="' + url + '"')
                  })
                  // attr.srcは処理不要
                  return { ...part, body }
                } else {
                  return part
                }
              })
            }
          })
        }
      })
    },
    async getAbsDownloadPublicSections (contentId) {
      // 画像URLを公開画像URLに置換する(画像は既に public に存在している)
      return this.$store.getters.getSectionAll.map(section => {
        return {
          ...section,
          parts_containers: section.parts_containers.map(partsContainer => {
            return {
              ...partsContainer,
              parts: partsContainer.parts.map(part => {
                if (part.type === 'Image' && part.attrs && !part.attrs['data-external-url'] && part.attrs['data-key']) {
                  const [ prefixAndSiteId, contentId, uuid ] = part.attrs['data-key'].split('/') // eslint-disable-line no-unused-vars
                  const publicUrl = `${process.env.VUE_APP_S3_PUBLIC_URL}/${prefixAndSiteId}/${contentId}/abs_export/${uuid}`
                  return {
                    ...part,
                    attrs: {
                      ...part.attrs,
                      src: publicUrl
                    }
                  }
                } else {
                  return part
                }
              })
            }
          })
        }
      })
    },
    hasEmptyImage () {
      for (const section of this.$store.getters.getSectionAll) {
        for (const partsContainer of section.parts_containers) {
          for (const part of partsContainer.parts) {
            if (part.type === 'Image' && !part.attrs['data-key']) {
              this.$store.commit('showErrorMessagePopup', ['画像が未設定のパーツがあります'])
              return true
            }
          }
        }
      }
      return false
    },
    // 本文サイズを計算する
    async getContentSize () {
      const formData = new FormData()
      formData.append('body', this.removePresignedImageUrl(this.rawHTML))
      formData.append('contentId', this.$route.params.id)
      formData.append('title', this.$store.getters.getContentInfo.name)
      formData.append('headCss', this.createHeadCSS())
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      formData.append('outlookCss', this.createOutlookCSS())

      // 本文サイズ(画像除く)を取得
      let htmlSize = 0
      const json = await this.$http({
        url: '/content/mail_size',
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        if (json.data.size) {
          htmlSize = json.data.size
        }
      }
      // コンテンツ画像サイズ(削除されている画像を取り除く)
      let imageSize = 0
      for (const section of this.$store.getters.getSectionAll) {
        for (const partsContainer of section.parts_containers) {
          for (const part of partsContainer.parts) {
            if (part.type === 'Image' && part.attrs['data-key']) {
              if (this.$store.state.contentImages[part.attrs['data-key']]) {
                imageSize += this.$store.state.contentImages[part.attrs['data-key']]['filesize']
              }
            }
            if (part.type === 'Code') {
              if (part.attrs && part.attrs.length > 0) {
                part.attrs.forEach(attr => {
                  if (attr['data-key']) {
                    imageSize += this.$store.state.contentImages[attr['data-key']]['filesize']
                  }
                })
              }
            }
          }
        }
      }
      // コンテンツ情報にコンテンツサイズをマージ
      this.$store.commit('mergeContentInfo', { size: htmlSize, imageSize: imageSize })
    },
    // 画像URLから、署名部分を削除
    removePresignedImageUrl (body) {
      const privateBucketUrls = this.$utils.image.getMultiplePrivateBucketUrl()

      // <img src="http://example.com/hoge/?fuga=fuga&piyo=piyo">の?以降、署名部分を抽出
      const reg = new RegExp(`<img[^>]*src=["']?((${privateBucketUrls[0]}|${privateBucketUrls[1]})+[^"']+(\\?[^"']*))?["']?.*?>`, 'g')
      // 署名部分を削除
      const matches = [...body.matchAll(reg)]
      matches.forEach(match => {
        // match[3]に署名部分が入る
        if (match[3]) {
          const regPresign = match[3].replace(/^\?/, '\\?')
          body = body.replace(new RegExp(regPresign, 'g'), '')
        }
      })
      return body
    },
    getPartsContainerOuterStyles (styles) {
      // outer-backgroundはbackgroundとして表示する
      let partsContainerStyles = JSON.parse(JSON.stringify(styles))
      if (partsContainerStyles && partsContainerStyles['outer-background']) {
        partsContainerStyles['background'] = partsContainerStyles['outer-background']
      }
      delete partsContainerStyles['outer-background']
      return partsContainerStyles
    }
  }
}
